(function() {
  let isUpdating = false;

  function getMegaMenuConfig() {
    const configEl = document.getElementById('mega-menus-config');
    if (configEl) {
      return {
        showChevron: configEl.dataset.showChevron === 'true',
        triggerMethod: configEl.dataset.triggerMethod || 'click'
      };
    }
    return { showChevron: true, triggerMethod: 'click' };
  }

  function initMegaMenu(forceUpdate = false) {
    if (isUpdating) return;
    
    const headerMenu = document.querySelector('header-menu');
    if (!headerMenu) return;

    isUpdating = true;

    try {
        const config = getMegaMenuConfig();
        const megaMenuTemplates = document.querySelectorAll('[data-mega-menu-template]');

        if (forceUpdate) {
            const cleanup = () => {
              const removeElements = (elements) => {
                  elements.forEach(el => {
                    const li = el.closest('li');
                    if (li) {
                        const link = li.querySelector('.menu-list__link');
                        if (link) {
                           link.removeAttribute('aria-haspopup');
                           link.removeAttribute('aria-expanded');
                           link.removeAttribute('aria-controls');
                           link.removeAttribute('data-click-listener');
                           li.removeAttribute('data-hover-listener');
                           li.classList.remove('has-submenu', 'mega-menu-trigger-hover', 'mega-menu-trigger-click', 'is-open');
                           const arrow = link.querySelector('.custom-mega-menu-arrow');
                           if (arrow) arrow.remove();
                        }
                    }
                    el.remove();
                  });
              };
              
              document.querySelectorAll('.custom-mega-menu-arrow').forEach(el => el.remove());

              const generated = headerMenu.querySelectorAll('[data-generated-submenu="true"]');
              removeElements(generated);

              const overflowList = headerMenu.querySelector('overflow-list');
              if (overflowList) {
                   const generatedInOverflow = overflowList.querySelectorAll('[data-generated-submenu="true"]');
                   removeElements(generatedInOverflow);
              }
              
              const injected = headerMenu.querySelectorAll('[data-mega-menu-injected="true"]');
              injected.forEach(el => {
                   if (!el.closest('[data-generated-submenu="true"]')) {
                       el.innerHTML = '';
                       el.removeAttribute('data-mega-menu-injected');
                       const submenu = el.closest('.menu-list__submenu');
                       if (submenu && submenu.hasAttribute('data-removed-dropdown')) {
                           submenu.classList.add('menu-list__submenu--dropdown');
                           submenu.removeAttribute('data-removed-dropdown');
                       }
                       const li = el.closest('li');
                       if (li && li.hasAttribute('data-removed-li-dropdown')) {
                           li.classList.add('menu-list__list-item--dropdown');
                           li.removeAttribute('data-removed-li-dropdown');
                       }
                   }
              });
              
              const themeArrows = headerMenu.querySelectorAll('.menu-list__chevron');
              themeArrows.forEach(arrow => arrow.style.display = '');
            };
            cleanup();
        }

        megaMenuTemplates.forEach(function(template) {
          const menuIndex = parseInt(template.getAttribute('data-menu-index'));
          if (!menuIndex || menuIndex < 1) return;
          
          const overflowList = headerMenu.querySelector('overflow-list');
          let menuItems = [];

          if (overflowList) {
            menuItems = Array.from(overflowList.children).filter(item => 
              item.tagName === 'LI' && item.classList.contains('menu-list__list-item')
            );
          } else {
            menuItems = Array.from(headerMenu.querySelectorAll('.menu-list__list-item'));
          }
          
          if (menuIndex > menuItems.length) return;

          const listItem = menuItems[menuIndex - 1];
          if (!listItem) return;
          
          const link = listItem.querySelector('.menu-list__link');
          if (!link) return;

          // Store original href and remove it to prevent navigation
          if (link.hasAttribute('href') && !link.hasAttribute('data-original-href')) {
            link.setAttribute('data-original-href', link.getAttribute('href'));
          }
          link.removeAttribute('href');
          link.style.cursor = 'pointer';

          // Remove any existing trigger classes
          listItem.classList.remove('mega-menu-trigger-hover', 'mega-menu-trigger-click');
          
          if (listItem.classList.contains('menu-list__list-item--dropdown')) {
              listItem.classList.remove('menu-list__list-item--dropdown');
              listItem.setAttribute('data-removed-li-dropdown', 'true');
          }
          
          // Apply Trigger Class
          listItem.classList.add(`mega-menu-trigger-${config.triggerMethod}`);

          // Inject Chevron (or remove if disabled)
          const existingThemeArrow = link.querySelector('.menu-list__chevron');
          const existingCustomArrow = link.querySelector('.custom-mega-menu-arrow');
          
          if (config.showChevron) {
             if (existingThemeArrow) {
                existingThemeArrow.style.display = '';
             } else if (!existingCustomArrow) {
                const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svg.setAttribute("class", "custom-mega-menu-arrow");
                svg.setAttribute("viewBox", "0 0 10 6");
                svg.setAttribute("fill", "none");
                svg.innerHTML = '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/>';
                link.appendChild(svg);
             }
          } else {
             if (existingCustomArrow) existingCustomArrow.remove();
             if (existingThemeArrow) existingThemeArrow.style.display = 'none';
          }

          // Trigger Logic
          if (config.triggerMethod === 'click') {
             // Block theme's native hover behavior
             if (!listItem.hasAttribute('data-hover-blocked')) {
                 listItem.setAttribute('data-hover-blocked', 'true');
                 
                 const blockHover = function(e) {
                     if (listItem.classList.contains('mega-menu-trigger-click')) {
                         e.stopImmediatePropagation();
                     }
                 };

                 listItem.addEventListener('pointerenter', blockHover, true);
                 listItem.addEventListener('mouseenter', blockHover, true);
                 listItem.addEventListener('mouseover', blockHover, true);
             }
             
              if (!link.hasAttribute('data-click-listener')) {
                  link.setAttribute('data-click-listener', 'true');
                  link.addEventListener('click', function(e) {
                      if (!listItem.classList.contains('mega-menu-trigger-click')) return;
                      
                      e.preventDefault();
                      e.stopPropagation();
                      const isOpen = listItem.classList.contains('is-open');
                      
                      // Close all others
                      document.querySelectorAll('.is-open').forEach(el => {
                          if (el !== listItem) {
                             el.classList.remove('is-open');
                          }
                      });

                      if (!isOpen) {
                          listItem.classList.add('is-open');
                          updateArrowPosition(listItem);
                          
                          // Manually set height for background
                          const submenu = listItem.querySelector('.menu-list__submenu');
                          const headerMenu = document.querySelector('header-menu');
                          if (submenu && headerMenu) {
                              if (!submenu.classList.contains('menu-list__submenu--dropdown')) {
                                  const height = submenu.offsetHeight;
                                  headerMenu.style.setProperty('--submenu-height', `${height}px`);
                                  headerMenu.style.setProperty('--submenu-opacity', '1');
                                  headerMenu.dataset.overflowExpanded = 'true'; // Help other styles know it's open
                              }
                          }
                      } else {
                          listItem.classList.remove('is-open');
                          const headerMenu = document.querySelector('header-menu');
                          if (headerMenu) {
                              headerMenu.style.setProperty('--submenu-height', '0px');
                              headerMenu.style.setProperty('--submenu-opacity', '0');
                              headerMenu.dataset.overflowExpanded = 'false';
                          }
                      }
                  });
              }
           } else {
              // Hover mode
              if (!listItem.hasAttribute('data-hover-listener')) {
                  listItem.setAttribute('data-hover-listener', 'true');
                  listItem.addEventListener('mouseenter', () => {
                      if (listItem.classList.contains('mega-menu-trigger-hover')) {
                          updateArrowPosition(listItem);
                      }
                  });
                  // Also prevent click navigation in hover mode
                  if (!link.hasAttribute('data-click-listener')) {
                    link.setAttribute('data-click-listener', 'true');
                    link.addEventListener('click', (e) => {
                         if (listItem.classList.contains('mega-menu-trigger-hover')) {
                             e.preventDefault();
                             e.stopPropagation();
                         }
                    });
                  }
              }
           }
          
          let existingSubmenu = listItem.querySelector('.menu-list__submenu');
          let submenuInner;
          const displayType = template.getAttribute('data-display-type');

          if (!existingSubmenu) {
            existingSubmenu = document.createElement('div');
            existingSubmenu.className = 'menu-list__submenu color-scheme-matches-parent';
            if (displayType === 'dropdown') {
                existingSubmenu.classList.add('menu-list__submenu--dropdown');
                listItem.classList.add('menu-list__list-item--dropdown');
                listItem.style.position = 'relative';
            }
            existingSubmenu.setAttribute('ref', 'submenu[]');
            existingSubmenu.setAttribute('data-generated-submenu', 'true');
            
            submenuInner = document.createElement('div');
            submenuInner.className = 'menu-list__submenu-inner';
            submenuInner.id = 'submenu-custom-' + Math.random().toString(36).substr(2, 9);
            
            existingSubmenu.appendChild(submenuInner);
            listItem.appendChild(existingSubmenu);
            
            link.setAttribute('aria-haspopup', 'true');
            link.setAttribute('aria-expanded', 'false');
            link.setAttribute('aria-controls', submenuInner.id);
            listItem.classList.add('has-submenu'); 
          } else {
            if (displayType === 'dropdown') {
                if (!existingSubmenu.classList.contains('menu-list__submenu--dropdown')) {
                    existingSubmenu.classList.add('menu-list__submenu--dropdown');
                    existingSubmenu.removeAttribute('data-removed-dropdown');
                }
                // ALWAYS run these for the parent item
                listItem.classList.add('menu-list__list-item--dropdown');
                listItem.style.position = 'relative';
            } else {
                if (existingSubmenu.classList.contains('menu-list__submenu--dropdown')) {
                    existingSubmenu.classList.remove('menu-list__submenu--dropdown');
                    existingSubmenu.setAttribute('data-removed-dropdown', 'true');
                }
                // ALWAYS clean up the parent item
                listItem.classList.remove('menu-list__list-item--dropdown');
                listItem.style.position = '';
            }
            submenuInner = existingSubmenu.querySelector('.menu-list__submenu-inner');
          }

          if (submenuInner) {
            const isInjected = submenuInner.hasAttribute('data-mega-menu-injected');
            
            if (forceUpdate || !isInjected) {
              submenuInner.innerHTML = template.innerHTML;
              submenuInner.setAttribute('data-mega-menu-injected', 'true');
              
              const uniqueId = template.content.querySelector('[data-mega-menu-search]')?.getAttribute('data-mega-menu-search');
              if (uniqueId) {
                initSearch(submenuInner, uniqueId);
              }
            }
          }
        });
        
        // Document click close
        if (!document.body.hasAttribute('data-mega-menu-click-handler')) {
            document.body.setAttribute('data-mega-menu-click-handler', 'true');
            document.addEventListener('click', function(e) {
                if (!e.target.closest('.is-open') && !e.target.closest('.menu-list__link')) {
                    document.querySelectorAll('.is-open').forEach(el => el.classList.remove('is-open'));
                    
                    const headerMenu = document.querySelector('header-menu');
                    if (headerMenu) {
                        headerMenu.style.setProperty('--submenu-height', '0px');
                        headerMenu.style.setProperty('--submenu-opacity', '0');
                        headerMenu.dataset.overflowExpanded = 'false';
                    }
                }
            });
        }

    } finally {
        setTimeout(() => {
            isUpdating = false;
        }, 0);
    }
  }

  function updateArrowPosition(listItem) {
      const submenu = listItem.querySelector('.menu-list__submenu');
      if (submenu) {
          const itemRect = listItem.getBoundingClientRect();
          const center = itemRect.left + (itemRect.width / 2);
          submenu.style.setProperty('--arrow-left', `${center}px`);
      }
  }

  function initSearch(container, id) {
    const searchInput = container.querySelector('[data-mega-menu-search="' + id + '"]');
    const brandsContainer = container.querySelector('[data-mega-menu-brands="' + id + '"]');
    
    if (searchInput && brandsContainer) {
      searchInput.addEventListener('click', function(e) {
         e.stopPropagation();
      });
      
      const redirectUrl = searchInput.getAttribute('data-search-redirect');
      
      const performRedirect = () => {
          const val = searchInput.value.trim();
          if (val) {
              window.location.href = `${redirectUrl}?q=${encodeURIComponent(val)}`;
          }
      };

      if (redirectUrl) {
          // Enter key on input
          searchInput.addEventListener('keydown', function(e) {
              if (e.key === 'Enter') {
                  e.preventDefault();
                  performRedirect();
              }
          });

          // Click on icon
          const searchIcon = searchInput.nextElementSibling;
          
          if (searchIcon && searchIcon.classList.contains('custom-mega-menu__search-icon')) {
              searchIcon.addEventListener('click', function(e) {
                  e.preventDefault();
                  e.stopPropagation();
                  performRedirect();
              });
          }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMegaMenu(false));
  } else {
    initMegaMenu(false);
  }

  // Observe for dynamic changes
  const observer = new MutationObserver(function(mutations) {
    // Check if config element changed
    for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.target.id === 'mega-menus-config') {
            initMegaMenu(true);
            return;
        }
        for (const node of mutation.addedNodes) {
            if (node.nodeType === 1 && (node.id === 'mega-menus-config' || node.hasAttribute?.('data-mega-menu-template'))) {
                initMegaMenu(true);
                return;
            }
        }
    }
    initMegaMenu(false);
  });

  // Observe document body for config changes
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-show-chevron', 'data-trigger-method'] });

  const headerMenu = document.querySelector('header-menu');
  if (headerMenu) {
    observer.observe(headerMenu, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-mega-menu-template]') || event.target.querySelector('#mega-menus-config')) {
       setTimeout(() => { initMegaMenu(true); }, 50);
    }
    if (event.target.querySelector('header-menu')) {
       const newHeaderMenu = event.target.querySelector('header-menu');
       observer.observe(newHeaderMenu, { childList: true, subtree: true });
       setTimeout(() => { initMegaMenu(false); }, 50);
    }
  });

  document.addEventListener('shopify:block:select', function(event) { initMegaMenu(true); });
  document.addEventListener('shopify:block:deselect', function(event) { initMegaMenu(true); });

})();
